import axios from 'axios';
import { apiBaseUrl } from './config';
import { logger } from '@/utils/logger';

export async function matchRefererWithFDLApps(referer) {
    try {
        const { data, status } = await axios.post(`${apiBaseUrl}/api/fdl/match_referer`, { referer_url: referer });
        if (status === 200) {
            // logger.log('Match FDL Apps:', data);
            return data.appid;
        }
    } catch (error) {
        if (error.response) {
            logger.error('No FDL Apps matched:', error.response.data);
        } else if (error.request) {
            logger.error('No response received:', error.request);
        } else {
            logger.error('Error setting up request:', error.message);
        }
    }
    return null;
}

export async function getDynamicLinkById(appid) {
    try {
        const { data, status } = await axios.post(`${apiBaseUrl}/api/fdl/dynamic_link`, { appid });
        if (status === 200) {
            logger.log('Found dynamic link:', data);
            return data.url;
        }
    } catch (error) {
        if (error.response) {
            logger.error('No FDL Apps matched:', error.response.data);
        } else if (error.request) {
            logger.error('No response received:', error.request);
        } else {
            logger.error('Error setting up request:', error.message);
        }
    }
    return null;
}
